require('./users-edit-container.scss')

module.exports = {
  template: require('./users-edit-container.pug')()
  controller: require('./users-edit-container.ctrl')
}
